<template>
  <div style="height:100%">
    <!-- <SplitContainer2 style="height:100%" layout="horizontal">
      <template #table1> -->
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="ApproveTypeSettingRef" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="false" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" @on_query="on_query" @state_change="state_change"
        :show_toolbar_button="[0, 0, 1, 1, 0]" @current_changed="current_changed"
        @on_cell_button_click="on_cell_button_click" tableref="a7ca531ecb3648c4b9fdf4313bc1b99b">
        <template #query>
          {{ $t("common.type") + $t("common.name") }}：<el-input size="small" v-model="DocumentType"
            style="width: 120px"></el-input>
          {{ $t("common.approved") + $t("common.type") }}：<el-input size="small" v-model="ApproveType"
            style="width: 120px"></el-input>
        </template>
        <template #toolbar="">
          <el-button type="info" plain @click="createForm('new')" class="ml-2 iconfont icon-add-new" size="mini">
            {{ $t("common.new") }}
          </el-button>
        </template>
      </TableMain>
    </BaseContainer>

    <!-- 新增修改 -->
    <BaseModal ref="bvModal" :title="modal_title" @saveData="saveData">
      <template #modal_content>
        <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px" class="demo-dataForm">
          <el-col :span="24">
            <el-form-item :label="$t('common.type') + $t('common.name')" prop="DocumentType">
              <el-input v-model="dataForm.DocumentType"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item :label="$t('common.approved') + $t('common.type')" prop="ApproveType">
              <el-input v-model="dataForm.ApproveType"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('common.approved') + $t('common.grade')" prop="ApproveLevel">
              <el-input v-model="dataForm.ApproveLevel" type="number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('common.description')" prop="description">
              <el-input v-model="dataForm.description"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"
import BaseModal from "../components/modals/baseModal"
import TestQueryPanel from "../components/base/TestQueryPanel"
import SplitContainer2 from "../components/container/SplitContainer2"
import * as ApproveTypeSettingController from "../../controllers/system/ApproveTypeSettingController"

export default {
  name: "PropertyManage",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
    SplitContainer2,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_approve_type",
      },
      modal_title: "create_approve_type",
      fields: ApproveTypeSettingController.fields,
      dataForm: _.cloneDeep(ApproveTypeSettingController.dataForm),
      rules: ApproveTypeSettingController.rules,
      DocumentType: "",
      ApproveType: "",
    }
  },
  created() { },
  methods: {
    //#region 查询
    async on_query(set_data) {
      let _this = this

      let _params = { id: { ">": 0 } }
      if (this.DocumentType != "") {
        _params.DocumentType = { like: "%" + this.DocumentType + "%" }
      }
      if (this.ApproveType != "") {
        _params.ApproveType = { like: "%" + this.ApproveType + "%" }
      }
      let _result = await ApproveTypeSettingController.methods.getData(_params)
      if (_result && _result[0].length > 0) {
        set_data(_.orderBy(_result[0], ["id"], ["asc"]))
      } else {
        set_data([])
      }
    },
    ///cell click
    async on_cell_button_click(data) {
      for (var i in this.dataForm) {
        if (_.isNull(data.item[i])) {
          this.dataForm[i] = ""
        } else {
          this.dataForm[i] = data.item[i]
        }
      }
      this.createForm("edit")
    },
    //#endregion

    //#region 保存
    ///初始化编辑界面
    createForm(code) {
      let title = ""
      switch (code) {
        case "new":
          title = "create_approve_type"
          this.dataForm = _.cloneDeep(ApproveTypeSettingController.dataForm)
          break
        case "edit":
          title = "edite_approve_type"
          break
      }
      this.modal_title = title
      this.$refs.bvModal.show()
    },
    ///新增修改
    saveData(cb) {
      let _this = this
      this.$refs.dataForm.validate(async (valid) => {
        if (valid) {
          let _data = _.cloneDeep(_this.dataForm)
          ///保存数据
          let _items = []
          _items.push(_data)
          let _result = await ApproveTypeSettingController.methods.upData({
            selected_items: _items,
          })

          if (_result.length > 0) {
            let data = _result[0].Result.Data[0][0]

            let _m = _.find(this.$refs.ApproveTypeSettingRef.my_data, {
              id: data.id,
            })
            if (_m) {
              _m.DocumentType = data.DocumentType
              _m.ApproveType = data.ApproveType
              _m.ApproveLevel = data.ApproveLevel
              _m.description = data.description
            } else {
              this.$refs.ApproveTypeSettingRef.AppendItems([data])
            }
            _this.msgToasts(this.$t("notify.action_successfully"), "success")
            cb(true, true)
          } else {
            _this.msgToasts(this.$t("notify.action_unsuccessfully"), "info")
            cb(false)
          }
        } else {
          cb(false)
          return false
        }
      })
    },
    //#endregion

    //#region 状态切换
    async state_change(data, cb) {
      if (data.state == "deleted" || data.state == "valid") {
        cb(false)
        return
      }

      let _result = await ApproveTypeSettingController.methods.upData(data)

      if (_result.length > 0) {
        ///成功
        _.each(data.selected_items, (t) => {
          let _m = _.find(this.$refs.ApproveTypeSettingRef.my_data, {
            id: t.id,
          })
          if (_m) {
            _m.is_approved = _result[0].Result.Data[0][0].is_approved
          }
        })
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true, true)
      } else {
        ///失败
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    //#endregion

    current_changed(old, current) {

      this.$emit("current_changed", old, current)
    },
  },
}
</script>
